import React from "react";
import { icons } from "icons";

const TipoProductoTab = ({ value, onChange }) => {
  return (
    <div style={{ width: "100%" }}>
      <div
        style={{
          display: "flex",
          width: "100%",
          gap: "6px",
        }}
      >
        <button
          type="button"
          onClick={() => onChange("simple")}
          style={tabStyle(value === "simple")}
        >
          <img
            src={
              value === "simple"
                ? icons.tab1_blanco
                : icons.tab1_negro
            }
            alt=""
            width="20"
            height="20"
            style={{ marginRight: 6, verticalAlign: "middle" }}
          />
          Simple
        </button>

        <button
          type="button"
          onClick={() => onChange("medida")}
          style={tabStyle(value === "medida")}
        >
          <img
            src={
              value === "medida"
                ? icons.tab2_blanco
                : icons.tab2_negro
            }
            alt=""
            width="20"
            height="20"
            style={{ marginRight: 6, verticalAlign: "middle" }}
          />
          Con medida
        </button>

        <button
          type="button"
          onClick={() => onChange("fraccionado")}
          style={tabStyle(value === "fraccionado")}
        >
          <img
            src={
              value === "fraccionado"
                ? icons.tab3_blanco
                : icons.tab3_negro
            }
            alt=""
            width="20"
            height="20"
            style={{ marginRight: 6, verticalAlign: "middle" }}
          />
          Fraccionado
        </button>
      </div>
    </div>
  );
};

const tabStyle = (active) => ({
  flex: 1,
  padding: "7px 0",
  cursor: "pointer",
  borderRadius: "8px",
  textAlign: "center",
  color: active ? "#fff" : "#000",
  backgroundColor: active ? "#272727" : "#d1d1d1",
  transition: "background-color 0.2s ease",
  border: "none",      
  outline: "none", 
});

export default TipoProductoTab;